import React, { useEffect, useState } from 'react';
import DialogComponent from '../layouts/DialogComponent';
import { Grid } from '@mui/material';
import { useUserSettings } from '../../store/usersettings-context';
import useIsMobile from '../../utils/useIsMobile';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

const CalendarSettingsDialog = ({ backgroundColor = '#5D3B9E', footer = '', setOpenDialog = () => {}, setIsBlur = () => {} }) => {
    const { userSettings, update } = useUserSettings();
    const isMobile = useIsMobile();

    const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const [calendarSettings, setCalendarSettings] = useState(userSettings?.calendarEvents ?? {
        allowConversationRequests: true,
        adminLevel: 'broadcaster',
        timeZone: systemTimeZone
    });

    const ianaZones = Intl.supportedValuesOf('timeZone');

    const timeZoneOptions = ianaZones.map((zone) => ({
        label: zone,
        value: zone
    }));

    const adminLevelOptions = [
        { label: 'Broadcaster', value: 'broadcaster' },
        { label: 'Broadcaster and moderators', value: 'moderator' },
        { label: 'Broadcaster, moderators, and VIPs', value: 'vip' }
    ];

    useEffect(() => {
        if (!calendarSettings.timeZone || !ianaZones.includes(calendarSettings.timeZone)) {
            setCalendarSettings(prev => ({
                ...prev,
                timeZone: systemTimeZone
            }));
        }
    }, []);

    const handleSave = () => {
        update({ calendarEvents: calendarSettings });
        setIsBlur(false);
        setOpenDialog(false);
    };

    return (
        <DialogComponent footer={footer} maxHeight='60vh' minWidth='40vw'>
            <Grid container spacing={3} style={{ padding: isMobile ? '1rem' : '2rem' }}>
                <Grid item xs={12}>
                    <Grid container spacing={4}>
                        <Grid item xs={10}>
                            <h3 style={{margin: 0, float: 'left'}}>Allow creating events through conversation:</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <InputSwitch checked={calendarSettings.allowConversationRequests} style={{float: 'right'}} onChange={(e) =>
                                    setCalendarSettings(prev => ({
                                        ...prev,
                                        allowConversationRequests: e.value
                                    }))
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={4}>
                        <Grid item xs={5}>
                            <h3 style={{ margin: 0, float: 'left', marginTop: '10px' }}>Who can create events:</h3>
                        </Grid>
                        <Grid item xs={7}>
                            <Dropdown value={calendarSettings.adminLevel} options={adminLevelOptions} style={{width: '100%'}} disabled={!calendarSettings.allowConversationRequests}
                                onChange={(e) =>
                                    setCalendarSettings(prev => ({
                                        ...prev,
                                        adminLevel: e.value
                                    }))
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={4}>
                        <Grid item xs={5}>
                            <h3 style={{margin: 0, float: 'left', marginTop: '10px'}}>Your timezone:</h3>
                        </Grid>
                        <Grid item xs={7}>
                            <Dropdown value={calendarSettings.timeZone} options={timeZoneOptions} style={{width: '100%'}} filter
                                onChange={(e) =>
                                    setCalendarSettings(prev => ({
                                        ...prev,
                                        timeZone: e.value
                                    }))
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginTop: '16px' }}>
                    <Button label="Save" icon="pi pi-save" severity="success" style={{ width: '50%', maxWidth: '300px' }} onClick={handleSave} />
                </Grid>
            </Grid>
        </DialogComponent>
    );
};

export default CalendarSettingsDialog;